import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cng-switch',
  templateUrl: 'switch.component.html',
  styleUrls: ['./switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CngSwitchComponent {
  @Input() switchValue: boolean;
  @Input() switchId: string;
  @Input() switchName: string;
  @Input() switchDisabled: boolean;
  @Output() switchChange: EventEmitter<boolean> = new EventEmitter();

  triggerChange() {
    this.switchChange.emit(this.switchValue);
  }
}
